export default __webpack_public_path__ + "static/media/210430-Cloudxier Clients Logo-10.a2c967ba.png";